module.exports = {
  "zones": {
    "Pacific/Wallis": ["z", {
      "wallclock": -2177452800000,
      "format": "+12",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": -2177496920000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 44120000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};